import { render, staticRenderFns } from "./InstructorImage.vue?vue&type=template&id=04bd822d"
import script from "./InstructorImage.vue?vue&type=script&lang=js"
export * from "./InstructorImage.vue?vue&type=script&lang=js"
import style0 from "./InstructorImage.vue?vue&type=style&index=0&id=04bd822d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports